module.exports = __webpack_public_path__ + "static/media/akshat-srivastava.d6fe12ce.jpeg";